import { PublicClientApplication, BrowserAuthOptions, InteractionRequiredAuthError, Configuration } from "@azure/msal-browser";

const baseUrl = window.location.origin;
const msalConfig: Configuration = {
  auth: {
    clientId: "105cc284-6574-4f30-941f-2d5a288902b9",
    authority: "https://mirrorscapearcana.b2clogin.com/mirrorscapearcana.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN", // your user flow
    knownAuthorities: ["mirrorscapearcana.b2clogin.com"],
    redirectUri: `${baseUrl}/Home/React`, // or your production URL
    postLogoutRedirectUri: `${baseUrl}/Home/React`
  },
  cache: {
    cacheLocation: "localStorage", // optional
    storeAuthStateInCookie: false,
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", "105cc284-6574-4f30-941f-2d5a288902b9"]
};

export default msalConfig;
